import { Box, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnimatedBlueButton } from "src/components/common";

const Banner: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const fadeStart = 0;
      const fadeEnd = 300;
      const newOpacity = 1 - Math.min(Math.max((scrollTop - fadeStart) / (fadeEnd - fadeStart), 0), 1);
      setOpacity(newOpacity);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        bgcolor: "white",
        maxWidth: "1920px",
        m: "0 auto",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "auto",
          position: "absolute",
          top: 0,
          img: {
            width: "100%",
            height: "auto",
            opacity: `${opacity + 0.3}`,
            objectFit: "inherit",
          },
        }}
      >
        <img src={require("src/assets/images/home/banner.jpg")} alt="" width={2000} height={1000} />
        <Box
          sx={{
            width: "100%",
            height: "200px",
            position: "absolute",
            bottom: "0px",
            background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)",
          }}
        />
        <Box
          sx={{
            width: "10vw",
            height: "100%",
            position: "absolute",
            top: "0px",
            left: "0px",
            background: "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)",
          }}
        />
        <Box
          sx={{
            width: "10vw",
            height: "100%",
            position: "absolute",
            top: "0px",
            right: "0px",
            background: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)",
          }}
        />
      </Box>
      <Box
        sx={{
          zIndex: 1,
          width: "100%",
          gridTemplateColumns: "repeat(12,1fr)",
          columnGap: "clamp(10px,.833vw,16px)",
          paddingInline: "clamp(16px,4.167vw,80px)",
          display: "grid",
          position: "relative",
          minHeight: "100vh",
          [theme.breakpoints.down(776)]: {
            gridTemplateColumns: "auto",
            paddingInline: "72px",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box
          sx={{
            zIndex: 3,
            gridArea: "1/2/2/6",
            gap: "clamp(30px,3.125vw,60px)",
            pt: "clamp(300px,21.979vw,422px)",
            opacity: opacity + 0.2,
            visibility: opacity === 0 ? "hidden" : "inherit",
            color: "#323e59",
            transform: `translate(0%, -${(1 - opacity) * 30}%)`,
            display: "flex",
            flexDirection: "column",
            [theme.breakpoints.down("lg")]: {
              gridArea: "1/3/2/8",
              justifyContent: "flex-end",
              alignSelf: "center",
              pb: "70px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "clamp(14px,1.25vw,24px)",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                whiteSpace: "pre-wrap",
                fontSize: "clamp(28px,3.125vw,60px)",
                fontWeight: 500,
                lineHeight: "inherit",
              }}
            >
              {t("home.banner.title")}
            </Typography>
            <Typography sx={{ fontSize: "clamp(14px,.833vw,16px)", fontWeight: 400, lineHeight: 1.6 }}>
              {t("home.banner.content")}
            </Typography>
          </Box>
          <AnimatedBlueButton text={t("home.banner.button")} />
        </Box>
      </Box>
    </Box>
  );
};
export default Banner;
